import React, { useState, useEffect } from 'react';
import TableGrid from '../../../../../../components/UI/TableGrid';
import SectionLoader from '../../../../../../components/UI/SectionLoader';
import VisitsService from '../../../../../../services/VisitsService';
import FileManagerService from '../../../../../../services/FileManagerService';
import { isSet, USDateTimeString } from '../../../../../../utils/commonUtils';

const ImagesList = (props) => {
  const mappingId = props.mappingId || props.mapping_id;
  const [isLoading, setIsLoading] = useState(false);
  const [documentsList, setDocumentsList] = useState({ tableHeaders: [], tableRows: { data: [] } });
  const [searchTerm, setSearchTerm] = useState('');
  const [activeSearchTerm, setActiveSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    sort_by: 'updated_at',
    sort_order: 'desc'
  }); 
  useEffect(() => {
    if (mappingId) {
      fetchDocumentList();
    }
  }, [mappingId]);

  const fetchDocumentList = async (search = activeSearchTerm, sortBy = pagination.sort_by, sortOrder = pagination.sort_order) => {
    try {
      setIsLoading(true);
      const response = await VisitsService.getPhysicalAttachementListByMapping(mappingId, search, sortBy, sortOrder);
      let documents = response?.data || [];
      let tableData = [];
      
      if (documents && Array.isArray(documents)) {
        tableData = documents.map((item) => {
          // Handle file structure - could be object with file_id or just a file object
          const fileData = typeof item.file === 'object' && item.file !== null 
            ? item.file 
            : item.snapFileManager || item.snap_file_manager || { file_id: item.file_id || item.id, original_name: item.file_name || item.name || 'File' };
          
          return {
            rowId: item.physical_attachment_id,
            data: {
              name: fileData,
              document_type: item.document_type || '-',
              updatedAt: USDateTimeString(item.updated_at),
              action: [{
                className: 'btn btn-icon btn-transparent-dark',
                iconType: 'Remove',
                acl: 'any',
                title: 'Delete',
                isDelete: true,
                clickHandler: () => deleteHandler(item.physical_attachment_id),
              }, {
                className: 'btn btn-icon btn-transparent-dark',
                iconType: 'Download',
                acl: 'any',
                title: 'Download',
                clickHandler: () => downloadHandler(fileData),
              }]
            }
          };
        });
      }
      
      setDocumentsList({ tableHeaders: getTableHeaders(), tableRows: { data: tableData } });
    } catch (error) {
      console.error("Error fetching documents:", error);
      props.Toast?.error("Failed to fetch images");
    } finally {
      setIsLoading(false);
    }
  };

  const getTableHeaders = () => [
    { label: 'File Name', key: 'name', type: 'FileType', sortName: 'file_name' },
    { label: 'Type', key: 'document_type', type: '', sortName: 'document_type' },
    { label: 'Updated Date', key: 'updatedAt', type: '', sortName: 'updated_at' },
    { label: 'Action', key: 'action', type: 'Actions' },
  ];

  const deleteHandler = async (documentId) => {
    // if (!window.confirm('Are you sure you want to delete this image?')) {
    //   return;
    // }
    
    try {
      setIsLoading(true);
      await VisitsService.deletePhysicalAttachement(documentId);
      props.Toast?.success('Image deleted successfully');
      fetchDocumentList();
    } catch (error) {
      console.error("Error deleting document:", error);
      props.Toast?.error("Failed to delete image");
    } finally {
      setIsLoading(false);
    }
  };

  const downloadHandler = async (fileData) => {
    try {
      if (fileData && fileData.file_id) {
        props.Loader?.(true);
        await FileManagerService.downloadFile(fileData.file_id, 'download');
        props.Loader?.(false);
      } else {
        props.Toast?.error("File not available for download");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      props.Toast?.error("Failed to download image");
      props.Loader?.(false);
    }
  };

  const handleSearchChange = (val) => {
    setSearchTerm(val);
  };

  const handleSearch = () => {
    setActiveSearchTerm(searchTerm);
    fetchDocumentList(searchTerm);
  };

  const handleClear = () => {
    setSearchTerm('');
    setActiveSearchTerm('');
    fetchDocumentList('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const fetchTableRecords = (newPagination) => {
    setPagination(newPagination);
    fetchDocumentList(activeSearchTerm, newPagination.sort_by, newPagination.sort_order);
  };

  return (
    <div className="sh_cardBox shadow-none border mb-0">
      <div className="sh_cardHeader">
        <div className="form-group d-flex mb-0 justify-content-between align-items-center">
          <h6 className="text-md mb-0">Uploaded Attachment</h6>
        </div>
      </div>
      <div className="sh_cardBody p-0">
        {/* Search Input and Buttons */}
        <div className="p-3 border-bottom">
          <div className="d-flex justify-content-end sh_filter_formheader">
            {/* Search Input */}
            <div className="d-flex p-1">
              <div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
            </div>
            {/* Action Buttons */}
            <div className="d-flex">
              <div className="addAction mr-2">
                <div className="btn-group p-1">
                  <button
                    className="btn btn-primary"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SectionLoader isLoading={isLoading} />
        {documentsList.tableRows.data.length > 0 ? (
          <TableGrid 
            {...documentsList} 
            pagination={pagination}
            fetchTableRecords={fetchTableRecords}
          />
        ) : (
          <div className="p-3 text-center text-muted">
            {activeSearchTerm ? 'No files found matching your search.' : 'No images uploaded yet.'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagesList;

